/* global angular */

var ngModule = angular.module('trends');

ngModule.directive('searchSelectionManager', function () {
    return {
        restrict: 'A',
        scope: true,
        controller: ['$scope', function ($scope) {
            $scope.selectionState = {};
            this.selectionDetail = {};

            this.setSelectionDetail = function (id, detail) {
                if ($scope.selectionState[id]) {
                    this.selectionDetail[id] = detail;
                } else {
                    delete this.selectionDetail[id];
                }
            };

            this.resetSelections = function () {
                $scope.selectionState = {};
                this.selectionDetail = {};
            };

            this.removeSelections = function (ids) {
                var that = this;
                angular.forEach(ids, function (id) {
                    $scope.selectionState[id] = false;
                    delete that.selectionDetail[id];
                });
            };

            this.getSelectionCount = function () {
                return Object.keys(this.selectionDetail).length;
            };
        }]
    };
});

/* Saves item detail to selection manager to allow later human-readable display of items */
ngModule.directive('searchSelectable', function () {
    return {
        require: ['^searchSelectionManager', 'ngModel'],
        restrict: 'A',
        scope: {
            getItem: '&searchSelectable',
            itemType: '@'
        },
        templateUrl: null,
        link: function (scope, element, attrs, ctrlrs) {
            var selectionCtrl = ctrlrs[0];
            var modelCtrl = ctrlrs[1];
            var item = scope.getItem();

            modelCtrl.$viewChangeListeners.push(function () {
                var selectionDetail = {
                    title: item.title,
                    type: scope.itemType
                };
                if (scope.itemType === 'mapp') {
                    selectionDetail.trendId = item.trend;
                    selectionDetail.hvtId = item.hvt_id;
                }
                selectionCtrl.setSelectionDetail(item.pk, selectionDetail);
            });
        }
    };
});
